import { render } from "./AppointmentsOfSaleProcess.vue?vue&type=template&id=2763b95c"
import script from "./AppointmentsOfSaleProcess.vue?vue&type=script&lang=js"
export * from "./AppointmentsOfSaleProcess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__